/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForResource extends models.ServiceAccountNativeDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForResource");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForResource.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForResource>): ServiceAccountNativeDetailsBaseForResource {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForResource(), model);
        ServiceAccountNativeDetailsBaseForResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForResource>): ServiceAccountNativeDetailsBaseForResource {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForResource.newInstance(<ServiceAccountNativeDetailsBaseForResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForResource) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForResource): boolean {
        if (models.ServiceAccountNativeDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
